module.exports = __webpack_public_path__ + "static/media/BSC.f4349d77.png";